import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import SystemAlertsView from "../views/SystemAlertsView.vue";
import MainMenuView from "../views/MainMenuView.vue";
import LoginView from "../views/LoginView.vue";
import Calendar from "../views/CalendarView.vue";
import ProductPriceLines from "../views/ProductPriceLines.vue";
import ProductPriceLinesEditMode from "../views/ProductPriceLinesEditMode.vue";
import ProductsBasket from "../views/ProductsBasket.vue";
import SelectPriceTypeView from "../views/SelectPriceTypeView.vue";
import SelectProductView from "../views/SelectProductView.vue";
import GroupsCustomerDetails from "../views/GroupCustomerDetailsView.vue";
import CustomerDetails from "../views/CustomerDetailsView.vue";
import SelectOrderClientType from "@/views/SelectOrderClientType.vue";
import SelectOrderType from "@/views/SelectOrderType.vue";
import SelectOrderBusinessClient from "@/views/SelectOrderBusinessClient.vue";
import SelectPaymentView from "@/views/SelectPaymentView.vue";
import ListOfPayment from "@/views/ListOfPayment.vue";
import CashPayment from "@/views/CashPayment.vue";
import CheckPayment from "@/views/CheckPayment.vue";
import BankTransferPayment from "@/views/BankTransferPayment.vue";
import CreditCardPayment from "@/views/CreditCardPayment.vue";
import OrderSuccessfullyCreated from "@/views/OrderSuccessfullyCreated.vue";
import ReservedOrderView from "@/views/ReservedOrderView.vue";
import ReservedOrderSearch from "@/views/ReservedOrderSearch.vue";
import CustomerDetailsEdit from "@/views/CustomerDetailsEdit.vue";
import ClubVoucherList from "@/views/ClubVoucherList.vue";
import ClubVoucherActions from "@/views/ClubVoucherActions.vue";
import ClubProductList from "@/views/ClubProductList.vue";
import ClubScanManual from "@/views/ClubScanManual.vue";
import ClubScan from "@/views/ClubScan.vue";
import DefaultEmpty from "@/views/DefaultEmpty.vue";

import { store } from "@/store";
import CloseShiftView from "@/views/CloseShiftView.vue";
import ShiftListView from "@/views/ShiftListView.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "",
    redirect: { name: "home" },
    component: () => import("@/layouts/SplittedLayout.vue"),
    children: [
      {
        path: "/home",
        name: "home",
        meta: {
          title: "Home",
        },
        components: {
          start: MainMenuView,
          end: SystemAlertsView,
        },
      },
      {
        path: "/select-price-type",
        name: "select-price-type",
        meta: {
          title: "Home",
        },
        components: {
          start: MainMenuView,
          end: SelectPriceTypeView,
        },
      },
      {
        path: "/select-products",
        name: "select-products",
        meta: {
          title: "New Order",
        },
        components: {
          start: SelectProductView,
          end: ProductsBasket,
        },
      },
      {
        path: "/calendar/:productId/:voucher?/:slotId?/:date?/:priceId?/:view?",
        name: "calendar",
        meta: {
          title: "Calendar",
          whole: true,
        },
        components: { whole: Calendar },
        props: true,
      },
      {
        path: "/calendar",
        name: "calendarView",
        meta: {
          title: "Calendar",
          whole: true,
        },
        components: { whole: Calendar },
      },
      {
        path: "/orderSuccessfullyCreated/:orderId",
        name: "orderSuccessfullyCreated",
        meta: {
          title: "Order created",
          whole: true,
        },
        components: { whole: OrderSuccessfullyCreated },
        props: true,
      },
      {
        path: "/product/:productId/price-lines/:slotId?/:dateStart?",
        name: "productPriceLines",
        meta: {
          title: "price-lines",
        },
        components: {
          start: ProductPriceLines,
          end: ProductsBasket,
        },
        props: true,
      },
      {
        path: "/product/:productId/price-lines/:slotId?/:dateStart?/edit",
        name: "productPriceLinesEditMode",
        meta: {
          title: "price-lines",
        },
        components: {
          start: ProductPriceLinesEditMode,
          end: ProductsBasket,
        },
        props: true,
      },
      {
        path: "/groupsCustomerDetails/save",
        name: "groupsCustomerDetailsSave",
        meta: {
          title: "groups-customer-details",
          save: true,
        },
        components: {
          start: GroupsCustomerDetails,
          end: ProductsBasket,
        },
        props: true,
      },
      {
        path: "/customerDetails/save",
        name: "customerDetailsSave",
        meta: {
          title: "customer-details",
          save: true,
        },
        components: {
          start: CustomerDetails,
          end: ProductsBasket,
        },
        props: true,
      },
      {
        path: "/groupsCustomerDetails",
        name: "groupsCustomerDetails",
        meta: {
          title: "groups-customer-details",
          save: false,
        },
        components: {
          start: GroupsCustomerDetails,
          end: ProductsBasket,
        },
        props: true,
      },
      {
        path: "/customerDetails",
        name: "customerDetails",
        meta: {
          title: "customer-details",
          save: false,
        },
        components: {
          start: CustomerDetails,
          end: ProductsBasket,
        },
        props: true,
      },
      {
        path: "/order/:productId/client-type",
        name: "clientType",
        meta: {
          title: "Order Client Type",
        },
        components: {
          start: SelectOrderClientType,
          end: ProductsBasket,
        },
        props: true,
      },

      {
        path: "/order/:productId/business-clients",
        name: "businessClients",
        meta: {
          title: "Select Business Client",
        },
        components: {
          start: SelectOrderBusinessClient,
          end: ProductsBasket,
        },
        props: true,
      },
      {
        path: "/order/type",
        name: "orderType",
        meta: {
          title: "Order Type",
        },
        components: {
          start: SelectOrderType,
          end: ProductsBasket,
        },
      },
      {
        path: "/order/select-payment",
        name: "selectPayment",
        meta: {
          title: "Select Payment",
        },
        components: {
          start: SelectPaymentView,
          end: ListOfPayment,
        },
      },
      {
        path: "/order/cash/:paymentIndex?",
        name: "cash",
        meta: {
          title: "Cash Payment",
        },
        components: {
          start: CashPayment,
          end: ListOfPayment,
        },
        props: true,
      },
      {
        path: "/order/check/:paymentIndex?",
        name: "check",
        meta: {
          title: "Check Payment",
        },
        components: {
          start: CheckPayment,
          end: ListOfPayment,
        },
        props: true,
      },
      {
        path: "/order/bankTransfer/:paymentIndex?",
        name: "bankTransfer",
        meta: {
          title: "Bank Transfer Payment",
        },
        components: {
          start: BankTransferPayment,
          end: ListOfPayment,
        },
        props: true,
      },
      {
        path: "/order/creditCard/:paymentIndex?",
        name: "creditCard",
        meta: {
          title: "Credit Card Payment",
        },
        components: {
          start: CreditCardPayment,
          end: ListOfPayment,
        },
        props: true,
      },
      {
        path: "/order/seach",
        name: "order-seach",
        meta: {
          title: "Find Reserved Order",
          whole: true,
        },
        components: { whole: ReservedOrderSearch },
      },
      {
        path: "/order/:orderId",
        name: "reservedOrder",
        meta: {
          title: "Reserved Order",
        },
        components: {
          start: CustomerDetailsEdit,
          end: ReservedOrderView,
        },
        props: true,
      },
      {
        path: "/club-voucher/list",
        name: "club-voucherList",
        meta: {
          title: "ClubsVouchers",
        },
        components: {
          start: ClubVoucherList,
          end: ClubVoucherActions,
        },
      },
      {
        path: "/club/:clubId/products",
        name: "clubProducts",
        meta: {
          title: "ClubsProducts",
        },
        components: {
          start: ClubProductList,
          end: ProductsBasket,
        },
        props: true,
      },
      {
        path: "/club/:clubId/scan",
        name: "clubScan",
        meta: {
          title: "ClubScan",
        },
        components: {
          start: ClubScan,
          end: ClubScanManual,
        },
        props: true,
      },
      {
        path: "/club/:clubId/scan/result",
        name: "clubScanResult",
        meta: {
          title: "ClubScan",
          save: false,
          voucher: true
        },
        components: {
          start: ClubScan,
          end: ProductsBasket,
        },
        props: true,
      },
      {
        path: "/close-shift",
        name: "closeShift",
        meta: {
          title: "Close shift",
          whole: true,
        },
        components: { whole: CloseShiftView },
        props: true,
      },
      {
        path: "/shift-list",
        name: "shiftList",
        meta: {
          title: "Shift list",
          whole: true,
        },
        components: { whole: ShiftListView },
        props: true,
      },
    ],
  },
  {
    path: "/login",
    name: "login",
    meta: {
      title: "Login",
      AllowAnonymous: true,
    },
    component: LoginView,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  const isAuthenticated = store.state.isAuthenticated;

  document.title = (to.meta.title as string) || "Bookit";
  if (!to.meta?.AllowAnonymous && to.name !== "login" && !isAuthenticated) {
    next({ name: "login" });
  } else if (isAuthenticated && to.meta?.AllowAnonymous) {
    next({ name: "home" });
  } else {
    if (isAuthenticated && !from.name && to.name !== "home") {
      next({ name: "home" });
    } else {
      next();
    }
  }
});

export default router;
